@if (isVisible) {
    <div class="fixed inset-0 w-screen h-full overflow-y-auto bg-gray-500 text-slate-900 bg-opacity-70 p-2 z-[100]">
        <div class="flex items-center justify-center align-middle pt-20">
            <div #dialogContainer class="w-[400px] h-[600px] bg-slate-50 rounded shadow flex flex-col">
                <div class="flex flex-row bg-ponder-light text-slate-50 stroke-slate-50 rounded-t shadow pr-2">
                    <div class="p-2 grow">Add '{{ name }}' to Deck</div>
                    <div (click)="onClose()" class="w-8 h-8 p-2 stroke-faded-50 hover:stroke-white hover:cursor-pointer">
                        <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                            <title>Close</title>
                            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
                        </svg>
                    </div>
                </div>
                <div class="flex flex-col overflow-y-auto grow text-sm">
                    @if (isLoading) {
                        <div class="p-2 pt-4">
                            <busy-spin></busy-spin>
                        </div>
                    } @else {
                        @if (!loadingSuccess) {
                            <generic-error></generic-error>
                        } @else {
                            <div class="bg-slate-100 shadow">
                                <table class="table-fixed w-[383px] text-center text-base">
                                    <thead>
                                        <tr>
                                            <th>Main</th>
                                            <th>Side</th>
                                            <th>Maybe</th>
                                            <!-- <th>Planning</th> -->
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div class="flex flex-col overflow-y-auto">
                                @for (deckTotal of decks ; track deckTotal.deck.deckId) {
                                    @if (isDeckVisible(deckTotal)) {
                                        <add-card-to-deck-input [parentRef]="this" [deckTotal]="deckTotal" [itemId]="itemId" [hasNormal]="hasNormal" [hasSpecial]="hasSpecial"></add-card-to-deck-input>
                                    }
                                }
                            </div>
                        }
                    }
                </div>
                <div class="p-2 flex flex-row gap-2 align-middle border-t text-sm bg-slate-100 rounded-b">
                    <div class="grow">
                        <input #deckFilterInput (input)="onFilterUpdated(deckFilterInput)" type="text" class="w-[18ch] p-2" placeholder="Filter on name ...">
                    </div>
                    <div class="p-2 flex flex-row gap-2 items-center align-middle grow">
                        <input #containingOnlyCheckbox (change)="onCheckboxToggle(containingOnlyCheckbox)" type="checkbox" id="containingOnly" name="containingOnly">
                        <label for="containingOnly">Containing Card</label>
                    </div>
                    <div>
                        <button (click)="onClose()" class="p-2 w-20 bg-slate-50 hover:bg-white rounded-sm shadow">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
}